import { TPayButtonVariant } from "../PayButton/PayButton.interface";
import { TButtonType } from "./Button.interface";

export const darkButtons: Array<TButtonType | TPayButtonVariant> = [
  "primary",
  "conversion",
  "apple-pay",
];
